import styled from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';
import { FooterFeature } from '@app/src/common/footer';
import { Button } from '@app/src/common/Button';

interface Props {
  color: string;
  colorRgb: string;
  bgImage: any;
}

export const Wrapper = styled.div`
  background: ${(props:Props) => props.bgImage && `url(${props.bgImage})`};
  background-size: cover;
  background-position: center;
  position: relative;
  height: auto;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    width: 8px;
    background-color: rgba(0, 0, 0, 0.25);
  }
  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #bbb;
  }
  &::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.1);
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: calc(100vh - 70px);
  }
`;

export const Halo = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: ${(props: Props) => props.colorRgb ? `${props.colorRgb}`: 'none' };

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: none;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
`;

export const Content = styled.article`
  position: relative;
  margin: auto;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px 0 36px;
  font-size: 14px;
  font-family: ${FONTS.OPEN_SANS};
  color: ${COLORS.GRAY_TEXT};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    background: rgba(255,255,255,.9);
    width: 646px;
    padding: 30px 0 20px;
    font-size: 18px;
    margin-left: 50px;
  }
`;

export const Head = styled.div`
  box-sizing: border-box;
  font-family: ${FONTS.ARISTOTELICA};
  height: 36px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: auto;
    margin-bottom: 15px;
  }
`;

export const IconWrapper = styled.span`
  display: inline-block;
  width: 40px;
  height: 36px;
  border-radius: 0 8px 8px 0;
  background: ${(props:Props) => props.colorRgb ? props.colorRgb : COLORS.GRAY_TEXT };
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 80px;
    height: 74px;
    svg {
      width: 55px;
      height: 55px;
    }
  }
`;

export const Title = styled.h2`
  margin-top: 10px;
  font-size: 24px;
  line-height: 16px;
  margin-left: 9px;
  color: ${(props: Props) => props.color ? props.color : '#e5e5e5'};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 34px;
    margin-left: 18px;
    line-height: 30px;
  }
`;

export const HighLights = styled.ul`
  padding: 0px 13px 28px 50px;
  max-width: 312px;
  list-style: none;
  margin: 0 auto;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
    margin: 0 75px 20px 100px;
  }
`;

export const Item = styled.li`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const SubtitleWrapper = styled.a`
  color: ${COLORS.BLACK};
  display: inline-block;
  position: relative;
  font-size: 21px;
  &:hover {
    &:before {
      content: '';
      border-top: 1px solid #333;
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
`;

export const Subtitle = styled.h3`
  font-weight: 400;
  margin: 0;
  color: ${COLORS.BLACK};
  display: flex;
  align-items: flex-start;
  svg {
    flex: 0 0 auto;
    margin: 7px 7px 0 0;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 21px;
    svg {
      width: 14px;
      height: 14px;
      margin-top: 8px;
    }
  }
`;

export const Description = styled.p`
  padding-left: 15px;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding-left: 22px;
  }
`;

export const ButtonAction = styled(Button)`
  font-size: 14px;
  font-weight: 600;
  min-height: 50px;
  flex-wrap: wrap;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
    min-height: 50px;
  }
`;

export const Publish = styled.span`
  width: 100%;
`;

export const Price = styled.span`
  font-size: 12px;
`;

export const ButtonPublish = styled(ButtonAction)`
  margin-bottom: 16px;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 0;
  }
`;

export const ButtonAgency = styled(ButtonAction)`
  margin: 0;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-right: 24px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    flex-direction: row-reverse;
    justify-content: center;
    margin-bottom: 20px;
  }
`;

export const Closure = styled.a`
  cursor: pointer;
  margin: 0 auto;
  font-weight: 600;
  font-size: 12px;
  color: ${(props: Props) => props.color ? props.color : '#e5e5e5'};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

export const Separator = styled.div`
  display: flex;
  padding: 0 30px;
  justify-content: space-between;
  align-items: center;
`;

export const RedSocial = styled.a`
  border-radius: 100%;
  background: ${COLORS.GRAY_PLACEHOLDER};
  cursor: pointer;
  margin-left: 0;
  display: none;
  width: 36px;
  height: 36px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const FooterWrapper = styled(FooterFeature)`
  display: none;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: block;
  }
`;

export const ButtonWrapper = styled.a`
  width: 280px;
  display: inline-block;
`;
